import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import { BaseTable } from '../../helpers';
import { GroupingsService } from '../../services';

import ReactTable from "react-table";
import i18next from "i18next";

const RowButton = ({ grouping, currSearch }) => (
  <div className="text-left">
    <Link
      to={{ pathname: `/monitoring/locations/${grouping.id}/assets`, state: { grouping: grouping, backLinkSearch: currSearch } }}
      className="btn btn-sm btn-default"
    >
      { i18next.t('form-labels.view') }
    </Link>
  </div>
);

const TableNameFilter = ({ searchValue, doSearch }) => (
  <div className="filter">
    <input
      style={{width: "100%", margin:"0 auto"}}
      value={searchValue}
      onChange={doSearch}
      type="text"
      name="search"
      placeholder={i18next.t('form-labels.search-by-name')}
      className="table-search"
      autoComplete="off"
    />
  </div>
);

const MonitoringGroupingListTable = ({ me, history, currSearch, currentGrouping, localErrorHandler }) => {
    const [loading, setLoading] = useState(false);
    const [groupingFilter, setGroupingFilter] = useState(null);
    const [parsedOptions, setParsedOptions] = useState(null);
    const [groupingsTable, setGroupingsTable] = useState({ data: [], loading: false, pages: 0, totalElements: 0, forcePage: null });
    const [potentialSearchValue, setPotentialSearchValue] = useState({ value: '', timeout: null });

    useEffect(() => {
        if (currSearch) {
            setParsedOptions(QueryString.parse(currSearch));
        } else {
            setParsedOptions({});
        }
    }, [currSearch]);

    useEffect(() => {
        if (parsedOptions) {
          const passedSearchValue = parsedOptions["search"];
          if (passedSearchValue) {
              setPotentialSearchValue({
                  value: passedSearchValue,
                  timeout: null,
              });
          }

          if (me.adhocRoleAssignment) {
              setGroupingFilter({ adHocLocations: me.availableGroupings, options: [], selected: [], searchValue: passedSearchValue });
          } else {
              setLoading(true);

              const groupingToQuery = currentGrouping ? currentGrouping : me.availableGroupings[0];

              GroupingsService.getAllWithAccess(groupingToQuery.id, true)
                  .then((response) => {
                      if (parsedOptions["filterByGroupingId"]) {
                          const filteredGrouping = response.groupings
                              .filter((group) => group.options.some((grouping) => grouping.value == parsedOptions["filterByGroupingId"]))
                              .map((group) => {
                                  return Object.assign({}, group).options.filter((grouping) => grouping.value == parsedOptions["filterByGroupingId"]);
                              });

                          if (filteredGrouping.length == 0 || !Array.isArray(filteredGrouping[0]) || filteredGrouping[0].length == 0) {
                            console.error('Could not find groupings from response.')
                            setGroupingFilter({
                                adHocLocations: null,
                                options: response.groupings,
                                selected: { value: groupingToQuery.id, label: groupingToQuery.name },
                                searchValue: passedSearchValue,
                            });
                          } else {
                            setGroupingFilter({
                                adHocLocations: null,
                                options: response.groupings,
                                selected: filteredGrouping[0][0],
                                searchValue: passedSearchValue
                            });
                          }
                      } else {
                          setGroupingFilter({
                              adHocLocations: null,
                              options: response.groupings,
                              selected: groupingFilter?.selected ?? { value: groupingToQuery.id, label: groupingToQuery.name },
                              searchValue: passedSearchValue
                          });
                      }

                      setLoading(false);
                  })
                  .catch((error) => {
                      console.error(error);
                      setLoading(false);
                      localErrorHandler(error.message);
                  });
          }
        }        
    }, [me, parsedOptions, currentGrouping, localErrorHandler]);

    const processData = ({ data, recordsTotal, currentPageSize, currentPage  }) => {
      const size = currentPageSize;
      const page = currentPage;
      const pageCount = Math.ceil(recordsTotal / size);

      setGroupingsTable({
        data: data,
        pages: pageCount,
        page: page,
        pageSize: size,
        forcePage: page >= pageCount && pageCount > 0 ? pageCount - 1 : null,
        loading: false,
        totalElements: recordsTotal
      });
    };

    const fetchData = useCallback((inTableData) => {
      if (parsedOptions && groupingFilter) {
        setGroupingsTable({ ...groupingsTable, loading: true });

        if (groupingFilter.adHocLocations) {
            processData({
                data: groupingFilter.adHocLocations,
                recordsTotal: groupingFilter.adHocLocations.size,
                currentPageSize: pageSize,
                currentPage: page,
            });
        } else {
          const options = BaseTable.buildFetchDataOptions(parsedOptions, []);
          BaseTable.buildURLOptions(inTableData, []).forEach((option) => {
            Object.keys(option).forEach(k => {
              var found = false;
              options.forEach((oo) => {
                if (oo[k]) {
                  oo[k] = option[k];
                  found = true;
                }
              });
              if (!found) {
                options.push(option);
              }
            });
          });

          GroupingsService.getAll(options).then((response) => {
            processData({
                data: Array.from(new Set(response.groupings.map((g) => g.id))).map((id) => response.groupings.find((g) => g.id === id)),
                recordsTotal: response.page.totalElements,
                currentPageSize: inTableData.pageSize,
                currentPage: inTableData.page,
            });
          }).catch(error => {
            console.error(error);
            setGroupingsTable({ ...groupingsTable, loading: false });
            localErrorHandler(error.message);
          });
        }
      }
    }, [parsedOptions, groupingFilter, localErrorHandler]);

    useEffect(() => {
      if (parsedOptions && groupingFilter) {
        var groupingIdToFilterBy = null;
        if (groupingFilter?.selected?.value && parsedOptions["filterByGroupingId"] != groupingFilter.selected.value) {
          groupingIdToFilterBy = `filterByGroupingId=${groupingFilter.selected.value}`;
        }

        var searchValueToFilterBy = null;
        if (groupingFilter?.searchValue && parsedOptions["search"] != groupingFilter.searchValue) {
          searchValueToFilterBy = `search=${groupingFilter.searchValue}`;
        }

        let pushToHistory = [];
        if (groupingIdToFilterBy) {
          pushToHistory.push(groupingIdToFilterBy);
          if (!searchValueToFilterBy && parsedOptions["search"]) {
            pushToHistory.push(`search=${parsedOptions["search"]}`);
          }
        } 
        if (searchValueToFilterBy) {
          if (!groupingIdToFilterBy && parsedOptions["filterByGroupingId"]) {
              pushToHistory.push(`filterByGroupingId=${parsedOptions["filterByGroupingId"]}`);
          }
          pushToHistory.push(searchValueToFilterBy);
        }

        if (pushToHistory.length > 0) {
          history.push(`?${pushToHistory.join('&')}`);
        }
      }
    }, [groupingFilter]);

    const doSearch = (val) => {
      if (potentialSearchValue.timeout) {
        clearTimeout(potentialSearchValue.timeout);
      }
      const value = val.target.value;
      setPotentialSearchValue({
        value: value,
        timeout: setTimeout(() => setGroupingFilter({...groupingFilter, searchValue: value}), 500)
      });
    };

    if (loading || groupingFilter == null) {
        return <div className="loader">{i18next.t("loading")}</div>;
    } else {
        const dynamicOptions = BaseTable.buildDynamicOptions(parsedOptions, groupingsTable.forcePage, []);

        return (
            <div>
                <div className="row">
                    <div className="col-xs-8 col-sm-7 col-md-4 pull-right">
                        <Select
                            options={groupingFilter.options}
                            isClearable={false}
                            name="selected-filter-by"
                            value={groupingFilter.selected}
                            onChange={(selection) => { setGroupingFilter({...groupingFilter, selected: selection}); }}
                            isSearchable={true}
                            className="business-filter"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            placeholder={i18next.t("select")}
                        />
                    </div>
                </div>

                <div className="react-table-custom">
                  <ReactTable
                    className="-striped -highlight"
                    manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                    data={groupingsTable.data}
                    pages={groupingsTable.pages} // Display the total number of pages
                    loading={groupingsTable.loading} // Display the loading overlay when we need it
                    onFetchData={fetchData} // Request new data when things change
                    showPaginationTop
                    totalElements={groupingsTable.totalElements}
                    defaultSorted={[{ id: 'name', desc: false }]}
                    columns={[
                      {
                        Header: i18next.t('table-headers.name'),
                        accessor: "name",
                        sortable: true,
                        minResizeWidth: 50,
                        filterable: true,
                        Filter: <TableNameFilter searchValue={potentialSearchValue.value} doSearch={doSearch} />
                      },
                      {
                        Header: i18next.t('table-headers.parent'),
                        accessor: "parent.name",
                        Cell: cell => cell.value ? <span>{cell.value}</span> : <span>{ i18next.t('none') }</span>,
                        sortable: true,
                        minResizeWidth: 50
                      },
                      {
                        Cell: cell => <RowButton grouping={cell.original} currSearch={currSearch} />,
                        sortable: false,
                        minResizeWidth: 50
                      }
                    ]}
                    {...dynamicOptions}
                  />
              </div>
            </div>
        );
    }
}

const MonitoringGroupingList = ({ me, history, currLocation, currSearch, currentGrouping, localErrorHandler }) => {
  if (me.availableGroupings.length === 1) {
    if (me.availableGroupings[0].monitoringVisible) {
      return <Redirect push to={{ pathname: `/monitoring/locations/${me.availableGroupings[0].id}/assets`, state: { backLinkSearch: currSearch } }} />;
    } else {
      localErrorHandler("You do not have access to any locations.");
      return null
    }
  } else {
    return <MonitoringGroupingListTable 
              me={me} 
              history={history}
              currLocation={currLocation}
              currSearch={currSearch}
              currentGrouping={currentGrouping}
              localErrorHandler={localErrorHandler}
            />
  }
};

export default ui({ key: 'grouping-list', persist: true, state: { selectedGroup: null, prevPage: null } })(
  connect(({ currentGrouping, user }) => ({ currentGrouping: currentGrouping.currentGrouping, me: user.me }))(
    MonitoringGroupingList
  )
);
